/**
 * designFlags — switch between the redesigned ("v2", Lovable) look and the
 * classic ("v1") look without touching data or behaviour.
 *
 *   localStorage.smc_design          = 'v1' | 'v2'   (whole app)
 *   localStorage.smc_design_<area>   = 'v1' | 'v2'   (one area overrides the global)
 *
 * Areas: splash, shell, home, reports, experiments. Default is v2 everywhere.
 */
const DEFAULT = 'v2';

function read(key) {
  try { return localStorage.getItem(key); } catch (_) { return null; }
}

export function designVersion(area) {
  const v = (area && read(`smc_design_${area}`)) || read('smc_design') || DEFAULT;
  return v === 'v1' ? 'v1' : 'v2';
}

export const isV2 = area => designVersion(area) === 'v2';

/** Set the global design and reload so every component re-reads it. */
export function setDesignVersion(v) {
  try {
    localStorage.setItem('smc_design', v === 'v1' ? 'v1' : 'v2');
    ['splash', 'shell', 'home', 'reports', 'experiments'].forEach(a => localStorage.removeItem(`smc_design_${a}`));
  } catch (_) {}
  window.location.reload();
}
